import 'js/src/libs/set-webpack-nonce';
import 'core-js/stable';
import 'js/src/libs/page-initialization';
import 'bootstrap';
import 'regenerator-runtime/runtime';

import 'css/src/limitless-deprecated/deprecated-core2.css';

import React from 'react';
import { createRoot } from 'react-dom/client';

import Emails from 'js/src/components/emails';
import { initCookieConsent } from 'js/src/libs/cookie-consent';
import { ErrorReporter, Project } from 'js/src/libs/error-reporter';

initCookieConsent();
ErrorReporter.init(Project.FRONTEND);

const container = document.getElementById('react-root');
if (!container) throw new Error('Could not find container element');
const root = createRoot(container);

root.render(<Emails />);
